import cx from 'classnames';
import typography from '~styles/typography.scss';
import { formatServerNameAsInitials } from '../../serverUtils';
import styles from './ServerBadge.scss';
import { SERVER_BADGE_COLORS } from './ServerFormContext';

interface ServerBadgeProps {
  serverName: string;
  badgeColor?: string;
  variant?: 'default' | 'small' | 'floorPlanYAxisStack';
}

export const ServerBadge = ({
  serverName,
  badgeColor,
  variant = 'default',
}: ServerBadgeProps) => {
  const badgeStyles = cx({
    [styles.container]: true,
    [typography.h8]: variant === 'default',
    [typography.t3_12]: ['small', 'floorPlanYAxisStack'].includes(variant),
    [styles.small]: variant === 'small',
    [styles.floorPlanYAxisStack]: variant === 'floorPlanYAxisStack',
  });
  const badgeTextColor = badgeColor
    ? SERVER_BADGE_COLORS.find((color) => color.backgroundColor === badgeColor)
        ?.textColor
    : 'white';

  return (
    <div
      data-testid="server-badge"
      className={badgeStyles}
      {...(badgeColor && {
        style: { backgroundColor: badgeColor, color: badgeTextColor },
      })}
    >
      {formatServerNameAsInitials(serverName)}
    </div>
  );
};
